import { Configuration } from '@videoblocks/search-gateway-client';

export const searchGatewayConfig = new Configuration({
    basePath: process.env.SEARCH_GATEWAY_HOST ?? 'http://search-gateway-staging-api.search-gateway.svc.cluster.local',
});
